<template>
    <Fragment>
        <!-- Modal -->
        <div class="modal modal_inform" :id="'modelInformUnsubscribe' + id" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">

                        <h5 class="modal-title title">Отписка от уведомлений</h5>
                        <button type="button" class="btn btn_lg btn_common btn_icononly" data-dismiss="modal" :id="'modelInformUnsubscribeClose' + id"><i
                                class="f7-icons icon_lg">xmark</i></button>

                    </div>
                    <div class="modal-body">

                        <div class="mt_xs">
                            Вы действительно хотите отписаться от сообщений о поступлении товара?
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn_lg btn_neutral mt_xxs"
                            data-dismiss="modal"
                        >
                            Закрыть
                        </button>
                        <button
                            type="button"
                            class="btn btn_lg btn_common mt_xxs"
                            @click.prevent="deleteFromInforms"
                        >
                            Отписаться
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {
    props: ["id", "email"],

    components: { Fragment },

    data: function () {
        return {
            item: null,
            ok: false,
        };
    },

    computed: {
    },

    methods: {        
        deleteFromInforms() {
            this.$store.dispatch('informs/deleteFromInforms', this.id);
            document.getElementById('modelInformUnsubscribeClose' + this.id).click();
        }
    },
};
</script>
